import Shader from "_src/engine/shader";
import Uniform from "_src/engine/uniform";
import { uniformType, uniformSource } from "_src/engine/constants";

import {vec3} from "_src/libs/gl-matrix";

import vertText from "_src/shaders/color_balance/color_balance.glslv";
import fragText from "_src/shaders/color_balance/color_balance.glslf";

export default class ColorBalanceShader extends Shader {

  constructor(params = {}) {

    super(params);

    this.attachUniforms(params);
    this.depthTest = false;

  }

  compile() {
    super.compile(vertText, fragText);
  }

  attachUniforms(params) {

    const low = "low" in params ? params.low : vec3.fromValues(0, 0, 0);
    const mid = "mid" in params ? params.mid : vec3.fromValues(0, 0, 0);
    const high = "high" in params ? params.high : vec3.fromValues(0, 0, 0);

    this.uniforms["u_text_diffuse"]   = new Uniform(uniformType.INT1, 0, uniformSource.OBJECT);
    this.uniforms["u_balanceLow"]     = new Uniform(uniformType.FLOAT3, low);
    this.uniforms["u_balanceMid"]     = new Uniform(uniformType.FLOAT3, mid);
    this.uniforms["u_balanceHigh"]    = new Uniform(uniformType.FLOAT3, high);

  }

  setBalanceLow(color) {
    this.setUniform("u_balanceLow", color);
  }

  getBalanceLow(dest) {
    return vec3.copy(dest, this.uniforms["u_balanceLow"].value);
  }

  setBalanceMid(color) {
    this.setUniform("u_balanceMid", color);
  }

  getBalanceMid(dest) {
    return vec3.copy(dest, this.uniforms["u_balanceMid"].value);
  }

  setBalanceHigh(color) {
    this.setUniform("u_balanceHigh", color);
  }

  getBalanceHigh(dest) {
    return vec3.copy(dest, this.uniforms["u_balanceHigh"].value);
  }

}
